import { render, staticRenderFns } from "./TeacherWorkLoadAvg.vue?vue&type=template&id=38011764"
import script from "./TeacherWorkLoadAvg.vue?vue&type=script&lang=js"
export * from "./TeacherWorkLoadAvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38011764')) {
      api.createRecord('38011764', component.options)
    } else {
      api.reload('38011764', component.options)
    }
    module.hot.accept("./TeacherWorkLoadAvg.vue?vue&type=template&id=38011764", function () {
      api.rerender('38011764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/TeacherWorkLoadAvg.vue"
export default component.exports